import React from 'react';
import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

const WidgetContentTimeline = (props) => {
  const list = props.childProps.payload.list;
  const param = props.childProps.payload.param;
  const preText = props.childProps.state.prevMessage;

  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  return (
    <>
      <div className="content-timeline">
        <div className="content-timeline-bon">
          <div className="title">본방</div>
          <div className="title-sub">{param} </div>
        </div>
        <div>
          <div className="title">편성</div>
          <div className="schedule-container">
            {list.map((item) => (
              <div className="episode" key={item.contentPartSerial}>
                {moment(item.startDate).format('MM.DD')} {item.C_startTime}
                <br />
                {item.subTitle}
              </div>
            ))}

            {/* <div className="episode">
              12일 01:00
              <br />
              에피소드 1
            </div>
            <div className="episode">
              12일 01:00
              <br />
              에피소드 1
            </div>
            <div className="episode">
              12일 01:00
              <br />
              에피소드 1
            </div> */}
          </div>
        </div>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText && (
            <div onClick={_prev} className="prev">
              <img src="/img/chatbot/icon_prev.png" />
              이전 단계로 이동
            </div>
          )}
          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default shopContext(withRouter(WidgetContentTimeline));
